import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from './config';

// webpack's require.context also emits alias keys without the leading "./"
// (e.g. "locales/en/website.json" alongside "./en/website.json") - only the
// "./<lng>/<ns>.json" form carries the locale/namespace we need, so skip the rest.
const context = require.context('../locales', true, /\.json$/);
const resources = {};
context.keys().forEach((key) => {
  const match = key.match(/^\.\/(\w+)\/(\w+)\.json$/);
  if (!match) return;
  const [, lng, ns] = match;
  resources[lng] = resources[lng] || {};
  resources[lng][ns] = context(key);
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: SUPPORTED_LOCALES,
    fallbackLng: DEFAULT_LOCALE,
    ns: ['website'],
    defaultNS: 'website',
    interpolation: { escapeValue: false },
    detection: { order: ['path', 'localStorage', 'navigator'], caches: ['localStorage'] },
  });

// The logged-in app isn't translated yet. Components it shares with the public website
// (e.g. the company details tab) are rendered in it through this English-only instance,
// so a Swedish website preference doesn't mix Swedish strings into the English app.
// A separate instance rather than i18n.cloneInstance(), which would share the language
// detector and overwrite the visitor's cached website language with "en".
export const appI18n = i18n.createInstance();
appI18n.init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  ns: ['website'],
  defaultNS: 'website',
  interpolation: { escapeValue: false },
  initAsync: false,
});

export default i18n;
